{
  "id": "campaign-138",
  "name": "Golden Field",
  "seed": "campaign:138",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.~...QQQQ.....r",
    ".~.:........:...",
    "..~:..a..a..:...",
    "...::::::::::...",
    "......a..a......",
    ".,..,........x..",
    ",,,,............",
    "....,....x......",
    "..a..a.#..a..a..",
    "::::::::::::::::",
    "..a.a.a..a.a.a..",
    "..............,.",
    "....a......a..,.",
    ",.....a..a....,.",
    ",a.::::::::::.a.",
    ",..:.....x.,:...",
    "...:.......,:...",
    "......QQQQ.....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 2,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 16
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 15,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    }
  ],
  "balls": {
    "first": 18,
    "every": 11
  },
  "generatorVersion": 3,
  "level": 138,
  "biome": "stadium",
  "par": {
    "reel": 9570,
    "push": 8438,
    "selfPropelled": 7818,
    "tractor": 6375,
    "zeroTurn": 5457,
    "fairway": 3189
  },
  "goldTime": {
    "reel": 9570,
    "push": 8048,
    "selfPropelled": 7674,
    "tractor": 6375,
    "zeroTurn": 5381,
    "fairway": 2992
  },
  "routeTries": {
    "par": {
      "reel": 11,
      "push": 15,
      "selfPropelled": 8,
      "tractor": 20,
      "zeroTurn": 21,
      "fairway": 19
    },
    "gold": {
      "reel": 11,
      "push": 25,
      "selfPropelled": 38,
      "tractor": 20,
      "zeroTurn": 46,
      "fairway": 34
    }
  }
}
